import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ExternalLoanAppResource from './ExternalLoanAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';

class HubExternalLoanAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'hub-external-loan';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'hubs/externals/loans';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'hubUuid',
            'externalLoanUuid',
            'manualLinked',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            externalLoan:             ExternalLoanAppResource,
            hub:             WorkspaceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            externalLoan: 'external_loan_uuid',
            hub: 'hub_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [
        ];
    }

}

export default HubExternalLoanAppResource;
